import { useQueryClient } from "@tanstack/react-query";

import useVehiclesMutations from "../../data/useVehiclesMutations";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { IVehicle, PartsPriority } from "../../models/Vehicle";

export default function PartsPriorityDropdown({ vehicle, classes = "" }: { vehicle: IVehicle, classes?: string }) {
  const queryClient = useQueryClient();
  const { update } = useVehiclesMutations();
  const { saveHandlers } = useDefaultCRUDHandlers("Priority Status");

  const handleStatusUpdate = (status: string) => {

    const updatedVehicle: IVehicle = {
      ...vehicle,
      partsPriority: parseInt(status),
    };

    update.mutate(updatedVehicle, {
      onSuccess: () => {
        queryClient.refetchQueries(["leads"]);
        saveHandlers.onSuccess();
      },
      onError: (error) => {
        saveHandlers.onError();
      }
    });
  }

  return (
    <div className="w-full h-full flex items-center" onClick={(e) => e.stopPropagation()}>
      <select value={vehicle.partsPriority} className={`${classes} border p-1`} onChange={(e) => handleStatusUpdate(e.target.value)}>
        {Object.values(PartsPriority).filter((ct) => isNaN(Number(ct))).map((status, i) => (
          <option key={status} value={i}>
            {status}
          </option>
        ))}
      </select>
    </div>
  )
}
